<template>
  <InputSelect
    classField="field mb-0"
    name="Marca"
    :modelValue="modelValue"
    @update:modelValue="value => $emit('update:modelValue', value)"
    :options="$store.state.implant_brands.map(({ name }) => name)"
  >
    <button class="button is-success" type="button" @click="openModalNewBrand = true" title="Aggiungi"><font-awesome-icon icon="plus" class="m-0" /></button>
  </InputSelect>

  <Modal :title="'Aggiungi marca'" :openModal="openModalNewBrand" @close="openModalNewBrand = false" @success="addBrand()" :loading="loading">
    <div class="field">
      <label class="label">Marca</label>
      <div class="control">
        <input class="input" type="text" placeholder="Marca" v-model="newBrand" />
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    modelValue: String
  },
  emits: ['update:modelValue'],

  data() {
    return {
      openModalNewBrand: false,
      newBrand: '',
      loading: false
    }
  },

  methods: {
    addBrand() {
      const self = this

      if (this.$store.state.implant_brands.find(brand => brand.name.toUpperCase() === self.newBrand.toUpperCase())) {
        alert('Marca già esistente!')
        return false
      }

      this.loading = true

      this.$http.post('/setting/add-brand', { name: self.newBrand })
      .then(function (response) {
        if (response && response.data) {
          self.$store.commit('setSettings', [response.data])

          self.$emit('update:modelValue', self.newBrand)

          self.openModalNewBrand = false
          self.newBrand = ''
          self.loading = false
        }
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },
  }
}
</script>